import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MediaQuery from 'react-responsive';

import { useSelector } from 'react-redux';
import { FetchLikePlusPointsToCash, FetchLikePlusRedemption } from 'Services/Apis/likePlus/likePlusServices';

import {
    Col,
    Form,
    Row,
    VertButton,
    VertCheckbox,
    VertContainer,
    VertIcon,
    VertInput,
    VertLoading,
    VertModal,
    VertTypography,
    message,
} from '@vertem-core/vertice-ds';

import { InfoCircleOutlined } from '@ant-design/icons';

import initialTokensValues from 'Assets/skins/default';
import 'Assets/styles/default/components/LikePlus/LikePlusRechargeStyles.less';

import { CheckoutModal2FA } from "../../2FA/CheckoutModal2FA";
import { useCheckoutProvider } from "../../Checkout/CheckoutProvider";
import OnboardingRedirectModal from 'components/Onboarding/OnboardingRedirectModal';
import LikePlusCustomTerms from '../LikePlusCustomTerms';

import Joi from 'joi';

import { currencyMask } from 'Utils/commons/cash';
import { onlyNumbersByDecimalPlaces } from 'Utils/onlyNumbers';
import { pointsMask } from 'Utils/commons/points';
import { stringToNumber } from 'Utils/commons/string';
import { convertPriceToPoints } from 'Utils/convertPoints';

import { cardCustomLabel, maxCardReload, minCardReload, reloadTime, purchaseRules } from 'Constants/LikePlus';

const LikePlusRecharge = () => {
    const [useForm] = Form.useForm();
    const navigate = useNavigate();
    const Balance = useSelector(({ Balance: data }) => data);
    const Catalog = useSelector(({ Catalog: data }) => data);
    const userInfos = useSelector(({ oidc: data }) => data);
    const Participants = useSelector(({ Participants: data }) => data);
    const userProfile = useSelector((state) => state.oidc.user.profile);
    const [orderId, setOrderId] = useState(null)
    const [orderStatus, setOrderStatus] = useState(null)
    const [purchaseData, setPurchaseData] = useState(null)
    const { handleAddErrors, errors } = useCheckoutProvider()

    const [isFormFilled, setIsFormFilled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
    const [errorMessages, setErrorMessages] = useState({});
    const [isTotalPointsChecked, setIsTotalPointsChecked] = useState(false);
    const [cashValue, setCashValue] = useState('0');
    const [formValues, setFormValues] = useState({ pointsQtd: 0 });
    const [isErrorModal, setIsErrorModal] = useState(false);
    const [errorModalMessage, setIsErrorModalMessage] = useState('');
    const [showOnboardingModal, setShowOnboardingModal] = useState(false);

    /* Vars */
    const [taxes, setTaxes] = useState({});

    const userTotalPoints = Balance && Balance.pointsValue ? Balance.pointsValue : 0;
    const { currencyConfiguration: { decimalPlaces, pointsName, conversionRate } } = Catalog;
    const formattedUserPoints = pointsMask(userTotalPoints, decimalPlaces, pointsName);
    const formattedPointsQtd = pointsMask(formValues.pointsQtd, decimalPlaces, pointsName);
    const disableButton = !isFormFilled || !acceptedTerms || isLoading;

    const likePlusReloadMinLimit = minCardReload;
    const likePlusReloadMaxLimit = maxCardReload;

    const formattedReloadMinLimit = pointsMask(
        minCardReload,
        decimalPlaces,
        pointsName
    );

    const formattedLikePlusReloadMaxLimit = pointsMask(
        maxCardReload,
        decimalPlaces,
        pointsName
    );

    const schema = Joi.object({
        pointsQtd: Joi.required().custom((value, helpers) => {
            const numericValue = stringToNumber(value);
            // caso nao digitar uma quantidade de pontos ou for quantidade zero
            if (!numericValue || numericValue === 0) {
                return helpers.message({ custom: `Digite a quantidade de ${pointsName} corretamente` });
            }
            // caso a quantidade de pontos for menor que 100
            if (likePlusReloadMinLimit !== null && numericValue < likePlusReloadMinLimit) {
                return helpers.message({ custom: `Não atinge o mínimo de ${formattedReloadMinLimit?.value} ${formattedReloadMinLimit?.label}` });
            }
            // caso o usuario nao tenha pontos suficiente
            if (numericValue < likePlusReloadMinLimit || numericValue > userTotalPoints) {
                return helpers.message({ custom: `Saldo insuficiente` });
            }
            if (likePlusReloadMaxLimit !== null && numericValue > likePlusReloadMaxLimit) {
                return helpers.message({ custom: `Ultrapassa o máximo de ${formattedLikePlusReloadMaxLimit?.value} ${formattedLikePlusReloadMaxLimit?.label}` });
            }
        }),
    });

    const fieldChangeHandler = (field, value) => {
        let updatedValue = value;

        if (field === 'pointsQtd') {
            updatedValue = value.replace(',', '.');
        }

        setFormValues((values) => ({ ...values, [field]: updatedValue }));
    };


    const useTotalPointsHandler = (value) => {
        setIsTotalPointsChecked(value);

        if (value) {
            setFormValues((values) => ({ ...values, pointsQtd: userTotalPoints }));
            useForm.setFieldsValue({ pointsQtd: formattedUserPoints.value });
        } else {
            setFormValues((values) => ({ ...values, pointsQtd: 0 }));
            setCashValue('0');
            useForm.setFieldsValue({ pointsQtd: '0' });
        }
    };

    const acceptTermsHandler = (value) => {
        setAcceptedTerms(value);
    };

    const termsModalOpenCloseHandler = () => {
        setIsTermsModalOpen(!isTermsModalOpen);
    };

    const validateAndSubmitHandler = async () => {
        try {
            const values = await useForm.validateFields();
            const { error } = schema.validate(values, { abortEarly: false });

            if (error) {
                const messages = {};
                error.details.forEach((err) => {
                    messages[err.context.key] = err.message;
                });
                setErrorMessages(messages);
                message.error('Existem erros no formulário.');
            } else {
                setErrorMessages({});
                redemptionCard();
            }
        } catch (errorInfo) {
            message.error('Houve um erro durante a validação do formulário.');
        }
    };

    const calculatePointsToCash = async (points) => {
        try {
            setIsLoading(true);
            const { data } = await FetchLikePlusPointsToCash(userInfos.user, points);
            setCashValue(data.money);
            const newTaxes = {};
            if (data.taxes && data.taxes.length > 0) {
            data.taxes.forEach((tax) => {
                newTaxes[tax.description] = tax.totalCalculedTax;
            });
            }

            setTaxes(newTaxes);
        } catch (error) {
            console.info('calculatePointsToCash error =>', error);
        } finally {
            setIsLoading(false);
        }
    };

    const redemptionCard = async () => {
        try {
            setIsLoading(true);
            const redemptionPayload = {
                totalMiles: cashValue,
                totalPoints: formValues.pointsQtd,
                transferKey: 'cpf',
                loyaltyNumber: Participants?.cpfCnpj.value,
                cpf: Participants?.cpfCnpj.value,
                participantName: Participants.name.value,
                orderItems: [
                    {
                        miles: cashValue,
                        packageName: `Crédito Cartão Pré-Pago ${cardCustomLabel}`,
                        quantity: 1,
                        totalPoints: convertPriceToPoints(
                            conversionRate,
                            decimalPlaces,
                            cashValue
                        ),
                    }
                ],
                offline: false,
                orderTypeId: 3
            };

            if (taxes) {
                Object.entries(taxes).forEach(([description, totalCalculedTax]) => {
                  redemptionPayload.orderItems.push({
                    miles: totalCalculedTax.toString(),
                    packageName: description,
                    quantity: 1,
                    totalPoints: convertPriceToPoints(
                      conversionRate,
                      decimalPlaces,
                      totalCalculedTax
                    ),
                  });
                });
            }

            setPurchaseData(redemptionPayload)
            const { data } = await FetchLikePlusRedemption(userInfos.user, redemptionPayload);

            if (data && ((data?.order?.liveOrderId) || data?.id) && data?.status !== 'RequiresTokenValidation' && !data?.errors) {
                const orderId = data.order.liveOrderId || data?.id;
                navigate(`/order-details?orderId=${orderId}&fromLikePlus=true`);
            } else if (data && data?.status === 'RequiresTokenValidation' && !data?.errors) {
                setOrderStatus(data?.status)
                setOrderId(((data?.order?.liveOrderId) || data?.id));
            } else if (data && data?.errors && typeof data?.errors === 'string' && /^(406)+/g.test(data?.errors)) {
                const errorString = data?.errors.replace('406 -', '').trim()
                const error = JSON.parse(errorString);
                switch (error.status) {
                    case 'AUTHENTICATIONREQUIRED':
                        setOrderStatus(error.errors[0].code)
                        setOrderId(error?.id);
                        break;
                    default:
                        handleAddErrors('likePlusRecharge2FA', {
                            title: "Não foi possível concluir.",
                            message: "Para garantir a segurança da sua conta, é necessário validar o seu número de telefone antes de prosseguir. Entre em contato com a central de atendimento."
                        })
                        setIsErrorModal(true);
                        setShowOnboardingModal(true);
                }
            } else {
                setIsErrorModalMessage(data.message);
                setIsErrorModal(true);
            }
        } catch (error) {
            if (error) {
                console.info('redemptionCard Error =>', error);
                setIsErrorModalMessage("Por favor tente novamente em instantes");
                setIsErrorModal(true);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const validateFormFilled = () => {
        const formValuesArray = Object.values(formValues);
        return formValuesArray.every(value => value !== '' && value !== '0' && value !== 0);
    };

    const designTokens = localStorage.getItem('designTokens');
    const initialTokensValuesFinal = (designTokens && JSON.parse(designTokens)) || initialTokensValues;
    const title = process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM_TITLE || "Cartão like mais";

    const desktopContent = (
        <VertContainer className='like-plus-recharge-component'>
            <Row>
                <Col className='like-plus-recharge-content col-9'>
                    <Row className='title'>
                        <Col className='col'>
                            <VertTypography.Title>
                                Preencha as informações para continuar a recarga:
                            </VertTypography.Title>
                        </Col>
                    </Row>

                    <Row className='name-document-field'>
                        <Col className='col-4'>
                            <VertInput
                                label="Nome Completo"
                                template="marketplace"
                                disabled
                                value={Participants.name.value}
                            />
                        </Col>
                        <Col className='col-4'>
                            <VertInput
                                label="CPF"
                                template="marketplace"
                                disabled
                                value={Participants?.cpfCnpj.value}
                                mask={[{
                                    mask: '000.000.000-00',
                                    lazy: true
                                }]}
                            />
                        </Col>
                    </Row>

                    <Row className='balance'>
                        <Col className='col'>
                            <VertTypography.Paragraph>
                                Seu saldo: {formattedUserPoints.value} {formattedUserPoints.label}
                            </VertTypography.Paragraph>
                        </Col>
                    </Row>

                    <Row className='points-to-use-fields'>
                        <Col className='points-value col-4'>
                            <VertTypography.Paragraph>
                                Recarga do cartão em {pointsName}
                            </VertTypography.Paragraph>

                            <Form.Item
                                name="pointsQtd"
                                initialValue=""
                                validateTrigger={['onBlur', 'onChange']}
                                help={errorMessages.pointsQtd}
                            >
                                <VertInput
                                    className={errorMessages.pointsQtd ? 'error-message' : ''}
                                    placeholder={`Digite a qtd. de ${pointsName}`}
                                    onChange={({ target }) => fieldChangeHandler('pointsQtd', target.value)}
                                    template="marketplace"
                                    onKeyPress={(e) => onlyNumbersByDecimalPlaces(e, decimalPlaces)}
                                    disabled={isTotalPointsChecked}
                                />
                            </Form.Item>
                        </Col>
                        <Col className='card-value col-4'>
                            <VertTypography.Paragraph>
                                Valor no cartão {cardCustomLabel}
                            </VertTypography.Paragraph>
                            {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                            {!isLoading && (
                                <VertInput
                                    value={currencyMask(Number(cashValue))}
                                    template="marketplace"
                                    disabled
                                />
                            )}
                        </Col>
                    </Row>

                    <Form.Item>
                        <VertCheckbox
                            className='total-points-value-checkbox'
                            name="total-points"
                            defaultChecked={false}
                            onChange={(e) => useTotalPointsHandler(e.target.checked)}
                        >
                            Usar todo meu saldo de {pointsName}
                        </VertCheckbox>
                    </Form.Item>

                    {
                        (minCardReload || maxCardReload) && (
                            <Row className='important-warning'>
                                <Col className='col'>
                                    <VertTypography.Paragraph className='important-warning-title'>
                                        <span>Regras de recarga</span>
                                    </VertTypography.Paragraph>

                                    {minCardReload && (
                                        <VertTypography.Paragraph type='light'>
                                            • Limite mínimo de {`${formattedReloadMinLimit?.value} ${formattedReloadMinLimit?.label}`}.
                                        </VertTypography.Paragraph>
                                    )}

                                    {maxCardReload && (
                                        <VertTypography.Paragraph type='light'>
                                            • Limite máximo de {`${formattedLikePlusReloadMaxLimit?.value} ${formattedLikePlusReloadMaxLimit?.label}`}.
                                        </VertTypography.Paragraph>
                                    )}

                                    {purchaseRules && (
                                        <VertTypography.Paragraph type='light'>
                                            • {purchaseRules}
                                        </VertTypography.Paragraph>
                                    )}
                                </Col>
                            </Row>
                        )
                    }

                    <Row className='important-warning'>
                        <Col className='col'>
                            <VertTypography.Paragraph className='important-warning-title'>
                                <span>Previsão de processamento da recarga</span>
                            </VertTypography.Paragraph>
                            <VertTypography.Paragraph className='important-warning-text'>
                                O crédito será processado em até {reloadTime}. Sempre que usar seu cartão, escolha a opção crédito.
                            </VertTypography.Paragraph>
                        </Col>
                    </Row>
                </Col>

                <Col className='like-plus-summary col-3'>
                    <VertTypography.Paragraph className='summary-title'>
                        Resumo do resgate
                    </VertTypography.Paragraph>

                    {Object.keys(taxes).length > 0 && (
                        <div className={'margin-bottom-small'}>
                        {Object.keys(taxes).map((key) => (
                            <VertTypography.Paragraph
                            className={'padding-top-small'}
                            key={key}
                            >
                            {key}: {currencyMask(parseFloat(taxes[key]))}
                            </VertTypography.Paragraph>
                        ))}
                        </div>
                    )}

                    <Col className="divider" />

                    {Object.keys(taxes).length > 0 && (
                        <div className={'margin-bottom-small'}>
                            {Object.keys(taxes).map((key) => (
                                <VertTypography.Paragraph
                                    className={'padding-top-small'}
                                    key={key}
                                >
                                    {key}: {currencyMask(parseFloat(taxes[key]))}
                                </VertTypography.Paragraph>
                            ))}

                            <Col className="divider" />
                        </div>
                    )}

                    <VertTypography.Paragraph className='summary-subtitle'>
                        Cartão {cardCustomLabel}
                    </VertTypography.Paragraph>

                    <VertTypography.Paragraph className='summary-text'>
                        Saldo adicionado: {' '}
                        {!isLoading && (cashValue ? currencyMask(Number(cashValue)) : 'R$ 0')}
                        {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                    </VertTypography.Paragraph>

                    <Col className="divider" />

                    <VertTypography.Paragraph className='summary-text' strong>
                        {`Total em ${pointsName}: `}
                        <strong>{!isLoading && (formValues.pointsQtd ? `${formattedPointsQtd.value} ${formattedPointsQtd.label}` : `0 ${formattedPointsQtd.label}`)}</strong>
                        {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                    </VertTypography.Paragraph>

                    <Col className="divider" />

                    <Col className='col-auto padding-x-none padding-y-none'>
                        <VertCheckbox
                            className='summary-checkbox'
                            name="total-points"
                            defaultChecked={false}
                            onChange={(e) => acceptTermsHandler(e.target.checked)}
                        >
                            Li e aceito o <a role='button' onClick={termsModalOpenCloseHandler}>Termo de uso</a>.
                        </VertCheckbox>
                    </Col>

                    <Col className='col-auto padding-x-none padding-y-none'>
                        <VertButton
                            type='highlight'
                            onClick={validateAndSubmitHandler}
                            loading={isLoading}
                            disabled={disableButton}
                        >
                            Finalizar resgate
                        </VertButton>
                    </Col>
                </Col>
            </Row>
        </VertContainer>
    );

    const mobileContent = (
        <VertContainer className='like-plus-recharge-component' spacingX='small' spacingY='small'>
            <Col className='like-plus-recharge-content'>
                <Row className='title'>
                    <Col className='col'>
                        <VertTypography.Title>
                            Preencha as informações para continuar a recarga:
                        </VertTypography.Title>
                    </Col>
                </Row>

                <Row className='name-field'>
                    <Col className='col'>
                        <VertInput
                            label="Nome Completo"
                            template="marketplace"
                            disabled
                            value={Participants.name.value}
                        />
                    </Col>
                </Row>

                <Row className='document-field'>
                    <Col className='col'>
                        <VertInput
                            label="CPF"
                            template="marketplace"
                            disabled
                            value={Participants?.cpfCnpj.value}
                            mask={[{
                                mask: '000.000.000-00',
                                lazy: true
                            }]}
                        />
                    </Col>
                </Row>

                <Row className='balance'>
                    <Col className='col'>
                        <VertTypography.Paragraph>
                            Seu saldo: {formattedUserPoints.value} {formattedUserPoints.label}
                        </VertTypography.Paragraph>
                    </Col>
                </Row>

                <Col className='points-to-use-fields'>
                    <Col className='points-value col'>
                        <VertTypography.Paragraph>
                            Recarga do cartão em {pointsName}
                        </VertTypography.Paragraph>
                        <Form.Item
                            name="pointsQtd"
                            initialValue=""
                            validateTrigger={['onBlur', 'onChange']}
                            help={errorMessages.pointsQtd}
                        >
                            <VertInput
                                className={errorMessages.pointsQtd ? 'error-message' : ''}
                                placeholder={`Digite a qtd. de ${pointsName}`}
                                onChange={({ target }) => fieldChangeHandler('pointsQtd', target.value)}
                                template="marketplace"
                                onKeyPress={(e) => onlyNumbersByDecimalPlaces(e, decimalPlaces)}
                                disabled={isTotalPointsChecked}
                            />
                        </Form.Item>
                    </Col>

                    <Form.Item>
                        <VertCheckbox
                            className='total-points-value-checkbox'
                            name="total-points"
                            defaultChecked={false}
                            onChange={(e) => useTotalPointsHandler(e.target.checked)}
                        >
                            Usar todo meu saldo de {pointsName}
                        </VertCheckbox>
                    </Form.Item>

                    <Col className='card-value col'>
                        <VertTypography.Paragraph>
                            Valor no {title}
                        </VertTypography.Paragraph>
                        {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                        {!isLoading && (
                            <VertInput
                                value={currencyMask(Number(cashValue))}
                                template="marketplace"
                                disabled
                            />
                        )}
                    </Col>
                </Col>

                {
                    (minCardReload || maxCardReload) && (
                        <Row className='important-warning'>
                            <Col className='col'>
                                <VertTypography.Paragraph className='important-warning-title'>
                                    <span>Regras da recarga</span>
                                </VertTypography.Paragraph>

                                {minCardReload && (
                                    <VertTypography.Paragraph type='light'>
                                        • Limite mínimo de {`${formattedReloadMinLimit?.value} ${formattedReloadMinLimit?.label}`}.
                                    </VertTypography.Paragraph>
                                )}

                                {maxCardReload && (
                                    <VertTypography.Paragraph type='light'>
                                        • Limite máximo de {`${formattedLikePlusReloadMaxLimit?.value} ${formattedLikePlusReloadMaxLimit?.label}`}.
                                    </VertTypography.Paragraph>
                                )}

                                {purchaseRules && (
                                    <VertTypography.Paragraph type='light'>
                                        • {purchaseRules}
                                    </VertTypography.Paragraph>
                                )}
                            </Col>
                        </Row>
                    )
                }

                <Row className='important-warning'>
                    <Col className='col'>
                        <VertTypography.Paragraph className='important-warning-title'>
                            <span>Previsão de processamento da recarga</span>
                        </VertTypography.Paragraph>
                        <VertTypography.Paragraph className='important-warning-text'>
                            O crédito será processado em até {reloadTime}. Sempre que usar seu cartão, escolha a opção crédito.
                        </VertTypography.Paragraph>
                    </Col>
                </Row>

                <Col className='like-plus-summary col'>
                    <VertTypography.Paragraph className='summary-title'>
                        Resumo do resgate
                    </VertTypography.Paragraph>

                    {Object.keys(taxes).length > 0 && (
                        <div className={'margin-bottom-small'}>
                        {Object.keys(taxes).map((key) => (
                            <VertTypography.Paragraph
                            className={'padding-top-small'}
                            key={key}
                            >
                            {key}: {currencyMask(parseFloat(taxes[key]))}
                            </VertTypography.Paragraph>
                        ))}
                        </div>
                    )}

                    <Col className="divider" />

                    {Object.keys(taxes).length > 0 && (
                        <div className={'margin-bottom-small'}>
                            {Object.keys(taxes).map((key) => (
                                <VertTypography.Paragraph
                                    className={'padding-top-small'}
                                    key={key}
                                >
                                    {key}: {currencyMask(parseFloat(taxes[key]))}
                                </VertTypography.Paragraph>
                            ))}

                            <Col className="divider" />
                        </div>
                    )}

                    <VertTypography.Paragraph className='summary-subtitle'>
                        {title}
                    </VertTypography.Paragraph>
                    <VertTypography.Paragraph className='summary-text'>
                        Saldo adicionado: {' '}
                        {!isLoading && (cashValue ? currencyMask(Number(cashValue)) : 'R$ 0')}
                        {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                    </VertTypography.Paragraph>
                    <Col className="divider" />
                    <VertTypography.Paragraph className='summary-text' strong>
                        {`Total em ${pointsName}: `}
                        <strong>{!isLoading && (formValues.pointsQtd ? `${formattedPointsQtd.value} ${formattedPointsQtd.label}` : `0 ${formattedPointsQtd.label}`)}</strong>
                        {isLoading && <VertLoading size={'small'} color={initialTokensValuesFinal['color-detached']} />}
                    </VertTypography.Paragraph>
                    <Col className="divider" />
                    <Col className='col-auto padding-x-none padding-y-none'>
                        <VertCheckbox
                            className='summary-checkbox'
                            name="total-points"
                            defaultChecked={false}
                            onChange={(e) => acceptTermsHandler(e.target.checked)}
                        >
                            Li e aceito o <a role='button' onClick={termsModalOpenCloseHandler}>Termo de uso</a>.
                        </VertCheckbox>
                    </Col>
                    <Col className='col-auto padding-x-none padding-y-none'>
                        <VertButton
                            type='highlight'
                            onClick={validateAndSubmitHandler}
                            loading={isLoading}
                            disabled={disableButton}
                        >
                            Finalizar resgate
                        </VertButton>
                    </Col>
                </Col>
            </Col>
        </VertContainer>
    );

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (formValues.pointsQtd > 0) {
                calculatePointsToCash(formValues.pointsQtd);
            } else if (formValues.pointsQtd < likePlusReloadMinLimit) {
                setCashValue('0');
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [formValues.pointsQtd]);

    useEffect(() => {
        const formFilled = validateFormFilled();
        setIsFormFilled(formFilled);
    }, [formValues]);

    return (<>
        <CheckoutModal2FA
            purchaseData={purchaseData}
            propsServiceName={"RECHARGEPLUS"}
            propsOrderId={orderId}
            propsStatus={orderStatus}
        />
        {/* {(() => {
            if (errors['likePlusRecharge2FA']) return (
                <>
                    <div className={`margin-bottom-regular`}>
                        <VertAlert
                            type='error'
                            className='toast-alert'
                            message={errors['likePlusRecharge2FA'].title || ''}
                            description={errors['likePlusRecharge2FA'].message}
                            closable={false}
                        />
                    </div>
                </>
            )

            return null
        })()} */}
        <Form
            name="likePlusRecharge"
            form={useForm}
        >
            <MediaQuery minWidth={769}>
                {desktopContent}
            </MediaQuery>

            <MediaQuery maxWidth={768}>
                {mobileContent}
            </MediaQuery>

            {isTermsModalOpen && (
                <VertModal
                    width={"45%"}
                    open={isTermsModalOpen}
                    onCancel={termsModalOpenCloseHandler}
                >
                    <LikePlusCustomTerms />
                </VertModal>
            )}

            {isErrorModal && (
                errors['likePlusGetYour2FA']
                    ? (
                        <OnboardingRedirectModal 
                            open={showOnboardingModal}
                            handleClose={() => showOnboardingModal(false)}
                        />
                    ) : (
                        <VertModal
                            open={isErrorModal}
                            onCancel={() => setIsErrorModal(false)}
                            template="marketplace"
                            spacing="regular"
                            rootClassName="like-plus-error-modal"
                        >
                            <Col className='like-plus-error-modal-content'>
                                <VertIcon component={InfoCircleOutlined} />
                                <VertTypography.Paragraph className='title'>
                                    Não foi possivel solicitar o seu cartão
                                </VertTypography.Paragraph>
        
                                <VertTypography.Paragraph className='message'>
                                    {errorModalMessage}
                                </VertTypography.Paragraph>
        
                                <VertButton type='highlight' onClick={() => setIsErrorModal(false)}>
                                    Entendi
                                </VertButton>
                            </Col>
                        </VertModal>
                    )
            )}
        </Form>
    </>);
};

export default LikePlusRecharge;
